import {getDocs, collection} from 'firebase/firestore';
import {database} from '../firebase';
import {VehicleCategory} from '@/types/interfaces/vehicle';

let cachedCategories: VehicleCategory[] = [];

export const getCategories = async (forceRefresh = false): Promise<VehicleCategory[]> => {
    if (!forceRefresh && cachedCategories.length > 0) {
        return cachedCategories;
    }

    if (!forceRefresh) {
        const stored = localStorage.getItem('cachedCategories');
        if (stored) {
            cachedCategories = JSON.parse(stored) as VehicleCategory[];
            return cachedCategories;
        }
    }

    try {
        const categoriesCollection = collection(database, 'categories');
        const categoriesSnapshot = await getDocs(categoriesCollection);

        if (categoriesSnapshot.empty) {
            cachedCategories = [];
        } else {
            cachedCategories = categoriesSnapshot.docs.map(doc => ({
                ...doc.data(),
                id: doc.id,
            } as VehicleCategory));
            localStorage.setItem('cachedCategories', JSON.stringify(cachedCategories));
        }
        return cachedCategories;
    } catch (error) {
        console.error('Error al obtener las categorías:', error);
        return [];
    }
}
